import React, { useState } from 'react';
import './App.css';
import ScoreBoard from './components/ScoreBoard';
import Throwaways from './components/Throwaways';

function App() {
  const [totalScore, setTotalScore] = useState<number>(0);
  const [isGameOver, setIsGameOver] = useState<boolean>(false);

  function endGame() {
    setIsGameOver(true);
  }

  return (
    <div className="App">
      <h1>William Moore's Simplified Solitaire Dice Score Card</h1>
      <div className={'rules'}><a href={'./rules.html'} rel={'noreferrer'} target={'_blank'}>The Rules</a></div>
      <div className={'total-score'}>Total Score: {totalScore}</div>
      {isGameOver && (
        <div className={'banner'}>{`The game is over and you scored ${totalScore} points.`}</div>
      )}
      {!isGameOver && (
        <div className={'banner'}>{`Roll them bones!`}</div>
      )}
      <div className={'game-sheet'}>
        <ScoreBoard totalScore={totalScore} setTotalScore={(newTotalScore: number) => setTotalScore(newTotalScore)} />
        <Throwaways gameOverCallback={endGame} />
      </div>
    </div>
  );
}

export default App;
